import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import _Object$create from "@babel/runtime-corejs3/core-js-stable/object/create";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import ClientFactory from '../client';
import OfflineProducerFactory from '../producer/offline';
import { releaseApiKey } from '../utils/inputValidation'; //
// Create SDK instance for offline mode.
//

function SplitFactoryOffline(context, sharedTrackers) {
  var sharedInstance = !sharedTrackers;
  var readiness = context.get(context.constants.READINESS);
  var storage = context.get(context.constants.STORAGE);
  var statusManager = context.get(context.constants.STATUS_MANAGER); // Producer

  var producer = sharedInstance ? undefined : OfflineProducerFactory(context); // Start background task for flag updates

  producer && producer.start();
  var api = _Object$assign(
  // Proto linkage of the EventEmitter to prevent any change
  _Object$create(statusManager),
  // GetTreatment/s
  ClientFactory(context),
  // Utilities
  {
    // Destroy instance. Async so we respect the online api.
    destroy: function destroy() {
      // Stop background jobs
      producer && producer.stop(); // Cleanup event listeners

      readiness.destroy(); // Cleanup storage

      storage.destroy && storage.destroy(); // Mark the factory as destroyed.

      context.put(context.constants.DESTROYED, true);
      !sharedInstance && releaseApiKey();
      return _Promise.resolve();
    }
  });
  return {
    api: api,
    metricCollectors: false // We won't collect any metrics on localhost mode.
  };
}
export default SplitFactoryOffline;